import React, { useEffect, useState, useContext } from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import PlayIcon from '../../../assets/Content-Icons/Svgs/play-circle.svg'
import SelectedTagIcon from '../../../assets/Content-Icons/Svgs/selected-tag-icon.svg'
import InformationTagIcon from '../../../assets/Content-Icons/Svgs/information-tag-icon.svg'
import CustomImage from 'src/components/customImage/customImage'

const CustomCard = ({
  onSelect = null,
  cardImage = '',
  playIconForVideo = false,
  fileName = '',
  leftText = '',
  rightText = '',
  isSelectable = false,
  isMutipleSelectable = false,
  isSelected = false,
  actionButton = '',
  actionButtonAction = {},
}) => {
  return (
    <div
      style={{
        width: '15.25%',
        aspectRatio: '183/134',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: `.5px solid ${isSelectable ? '#707070' : '#70707036'}`,
      }}
      className={`${isSelectable ? 'on-card-hover' : ''} on-card-selected`}
      tabIndex={0}
      onClick={isSelectable ? onSelect : null}
    >
      <div className="relative" style={{ height: '74%' }}>
        <CustomImage
          className="card-img-top"
          imageUrl={cardImage}
          loaderStyle={{ height: '100%' }}
          errorPlaceholder={ImageNotAvailable}
          alt={'Asset'}
          imgStyle={{
            opacity: isSelectable ? '1' : '.36',
            pointerEvents: isSelectable ? 'all' : 'none',
            height: '100%',
            width: '100%',
          }}
        />
        {isSelectable && (
          <img
            src={SelectedTagIcon}
            alt=""
            className={`selected-tag ${isSelected ? 'selected-content' : ''}`}
          />
        )}
        {!isSelectable && (
          <div className={`information-tag`}>
            <img src={InformationTagIcon} alt="" />
          </div>
        )}
        {playIconForVideo && (
          <div
            className="play-icon"
            style={{
              opacity: isSelectable ? '1' : '.36',
              pointerEvents: isSelectable ? 'all' : 'none',
            }}
          >
            <img src={PlayIcon} alt="" />
          </div>
        )}
      </div>
      <div
        className="d-flex justify-content-between px-1"
        style={{
          opacity: isSelectable ? '1' : '.36',
          pointerEvents: isSelectable ? 'all' : 'none',
        }}
      >
        <div style={{ fontSize: '10px', width: '88%' }}>
          <h6
            className="line-clamp-1"
            style={{ fontSize: '11px', margin: '.2ch 0', color: '#000' }}
          >
            {fileName}
          </h6>
          <div className="d-flex justify-content-between">
            <span>{leftText}</span>
            <span>{rightText}</span>
          </div>
        </div>
        <div
          style={{
            width: '6%',
            fontSize: '20px',
            fontWeight: '700',
            cursor: 'pointer',
          }}
          className="d-flex justify-content-center align-items-center position-relative preview-menu-dots"
        >
          <button style={{ border: 'none', outline: 'none', background: 'none' }}>⋮</button>
          <div
            className="position-absolute preview-menu-button"
            onClick={() => {
              actionButtonAction()
              onSelect()
            }}
            tabIndex={0}
          >
            {actionButton}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomCard

/*
.on-card-hover - Applies the hover effect to the card
.on-card-selected - Applies the selected effect to the card
.play-icon - Applies the play icon effect to the card which is of type "video", it is absolute on the thumbnail (search for the class for more)

displayAsListItem - display the card as a list item(if true) or a grid item(if false)

publish_time - start
live_exp_tiem - end time

/////// for live
*/
